import { useFormikContext } from 'formik'
import i18n from 'core/common/i18n'
import { getErrorMessage, validateField } from 'core/common/utils/validation'
import { MenuOption, Grid } from 'core/components/Core'
import TextField from 'core/components/TextField'
import { productTypeOptions } from './constants'
import * as S from './style'

const ProductType = ({ onChange, ...rest }) => {
  const { values, handleChange, handleBlur, errors, touched, submitCount } = useFormikContext()

  return (
    <>
      <Grid item xs={12} {...rest}>
        <S.Container>
          <TextField
            error={validateField('type', errors, touched, submitCount > 0)}
            onBlur={handleBlur}
            variant="outlined"
            helperText={getErrorMessage('type', errors, touched)}
            label={i18n.t('productNew.basicData.productTypeLabel')}
            name="type"
            value={values?.type}
            hiddenLabel
            fullWidth
            select
            onChange={e => {
              handleChange(e)
              if (onChange) onChange()
            }}
          >
            {productTypeOptions.map((productType, index) => (
              <MenuOption key={index} value={productType.value}>
                {productType.label}
              </MenuOption>
            ))}
          </TextField>
        </S.Container>
      </Grid>
    </>
  )
}

export default ProductType
